"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const selectors_1 = require("~/store/selectors");
const redux_1 = require("redux");
const controls_1 = require("~/components/common/controls");
const UI_1 = require("~/components/UI");
const actions_1 = require("~/store/actions");
const AddressEditModal_1 = __importDefault(require("../AddressEditModal"));
const AddressesBlock_1 = __importDefault(require("../AddressesBlock/AddressesBlock"));
const profileValidation_1 = __importDefault(require("../profileValidation"));
const CustomerProfileView_module_scss_1 = __importDefault(require("./CustomerProfileView.module.scss"));
function CustomerProfileView({ editMode, isSubmitted, submitHandler, disableSubmit }) {
    const { t } = (0, react_i18next_1.useTranslation)('profile');
    const user = (0, react_redux_1.useSelector)(selectors_1.selectCurrentUser);
    const [firstName, setFirstName] = (0, react_1.useState)();
    const [lastName, setLastName] = (0, react_1.useState)();
    const [phoneNumber, setPhoneNumber] = (0, react_1.useState)({ value: '', error: null });
    const [companyName, setCompanyName] = (0, react_1.useState)();
    const [editAddressMode, setEditAddressMode] = (0, react_1.useState)(false);
    const [selectedAddressId, setSelectedAddressId] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        if (isSubmitted) {
            submitHandler({ firstName, lastName, phoneNumber: phoneNumber.value, companyName });
        }
    }, [isSubmitted]);
    const { dispatchUpdateAddressDataAction, dispatchCreateAddressDataAction } = (0, redux_1.bindActionCreators)({
        dispatchUpdateAddressDataAction: actions_1.updateAddressDataAction,
        dispatchCreateAddressDataAction: actions_1.createAddressDataAction,
    }, (0, react_redux_1.useDispatch)());
    const phoneInputHandler = (key, value) => {
        setPhoneNumber({ value, error: phoneNumber.error });
    };
    const errors = {
        none: null,
        required: t('errors.phone-number'),
    };
    const phoneErrorHandler = (key, value) => {
        disableSubmit(true);
        setPhoneNumber({ value: phoneNumber.value, error: errors[value] });
    };
    (0, react_1.useEffect)(() => {
        var _a;
        if (user) {
            setFirstName(user.firstName);
            setLastName(user.lastName);
            setPhoneNumber({ value: (_a = user.phoneNumber) !== null && _a !== void 0 ? _a : '', error: phoneNumber.error });
            setCompanyName(user.companyName);
        }
    }, [user]);
    (0, react_1.useEffect)(() => {
        disableSubmit((0, profileValidation_1.default)(user, { firstName, lastName, phoneNumber: phoneNumber.value, companyName }, phoneNumber.error));
    }, [companyName, disableSubmit, firstName, lastName, phoneNumber, user]);
    const setEditAddressModeHandler = (mode) => {
        setEditAddressMode(mode);
    };
    const closeEditAddresModeHandler = () => {
        setSelectedAddressId(null);
        setEditAddressModeHandler(false);
    };
    const submitEditAddressHandler = (newAddress) => __awaiter(this, void 0, void 0, function* () {
        if (newAddress === null || newAddress === void 0 ? void 0 : newAddress.id) {
            dispatchUpdateAddressDataAction(newAddress);
        }
        else {
            dispatchCreateAddressDataAction(newAddress);
        }
        closeEditAddresModeHandler();
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: CustomerProfileView_module_scss_1.default.userData },
            react_1.default.createElement("div", { className: CustomerProfileView_module_scss_1.default.data },
                react_1.default.createElement("div", { className: CustomerProfileView_module_scss_1.default.info, "data-wide": true },
                    react_1.default.createElement("span", { className: CustomerProfileView_module_scss_1.default.title }, t('info.first-name')),
                    editMode ? (react_1.default.createElement(UI_1.Input, { type: "text", maxLength: 60, value: firstName, customErrors: { required: t('errors.first-name') }, onChange: setFirstName, onInput: setFirstName, required: true })) : (react_1.default.createElement("div", { className: CustomerProfileView_module_scss_1.default.fieldValue }, user === null || user === void 0 ? void 0 : user.firstName))),
                react_1.default.createElement("div", { className: CustomerProfileView_module_scss_1.default.info, "data-wide": true },
                    react_1.default.createElement("span", { className: CustomerProfileView_module_scss_1.default.title }, t('info.phone-number')),
                    editMode ? (react_1.default.createElement(controls_1.PhoneNumberInput, { state: phoneNumber, inputKey: "phoneNumber", onInput: phoneInputHandler, onError: phoneErrorHandler, required: true })) : (react_1.default.createElement("div", { className: CustomerProfileView_module_scss_1.default.fieldValue }, !(user === null || user === void 0 ? void 0 : user.phoneNumber) ? '-' : `+${user === null || user === void 0 ? void 0 : user.phoneNumber}`)))),
            react_1.default.createElement("div", { className: CustomerProfileView_module_scss_1.default.data },
                react_1.default.createElement("div", { className: CustomerProfileView_module_scss_1.default.info },
                    react_1.default.createElement("span", { className: CustomerProfileView_module_scss_1.default.title }, t('info.last-name')),
                    editMode ? (react_1.default.createElement(UI_1.Input, { type: "text", maxLength: 60, value: lastName, customErrors: { required: t('errors.last-name') }, onChange: setLastName, onInput: setLastName, required: true })) : (react_1.default.createElement("div", { className: CustomerProfileView_module_scss_1.default.fieldValue }, user === null || user === void 0 ? void 0 : user.lastName))),
                react_1.default.createElement("div", { className: CustomerProfileView_module_scss_1.default.info },
                    react_1.default.createElement("span", { className: CustomerProfileView_module_scss_1.default.title }, t('info.company')),
                    editMode ? (react_1.default.createElement(UI_1.Input, { type: "text", maxLength: 255, value: companyName !== null && companyName !== void 0 ? companyName : '', onChange: setCompanyName, onInput: setCompanyName })) : (react_1.default.createElement("div", { className: CustomerProfileView_module_scss_1.default.fieldValue }, !(user === null || user === void 0 ? void 0 : user.companyName) ? '-' : user === null || user === void 0 ? void 0 : user.companyName))))),
        !editAddressMode ? (react_1.default.createElement(AddressesBlock_1.default, { addressesArr: user === null || user === void 0 ? void 0 : user.shippingAddresses, setEditMode: setEditAddressModeHandler, setSelectedAddressId: (id) => setSelectedAddressId(id) })) : (react_1.default.createElement(AddressEditModal_1.default, { address: user === null || user === void 0 ? void 0 : user.shippingAddresses.filter((address) => address.id === selectedAddressId)[0], onClose: closeEditAddresModeHandler, onSubmit: submitEditAddressHandler }))));
}
exports.default = CustomerProfileView;
